import React from 'react';
import { getRiskConsequencesName, getRiskEventsName, getRiskSourcesName } from 'src/api/types';
import { linkifyText, Spacer } from 'src/common';
import { Label, Wrap } from './tableSheets.styles';
import FormulaPreview from 'src/components/FormulaPreview';
import { ScenarioLibraryItem } from '../sharedColumns/useScenarioLibraryColumns';
import * as S from './TableSheetScenarioLibrary.styles';

type ScenarioTemplate = ScenarioLibraryItem;

interface TableSheetScenarioLibraryProps {
  data: ScenarioTemplate;
}

export const TableSheetScenarioLibrary: React.FC<TableSheetScenarioLibraryProps> = ({ data }) => {
  return (
    <Wrap>
      <Label>AUTHOR</Label>
      <div className="value">{data.author || '-'}</div>
      <Spacer $px={10} />
      <Label>DESCRIPTION</Label>
      <div className="value">{data.description ? linkifyText(data.description) : '-'}</div>
      <Spacer $px={15} />
      <div className="divider" />
      <Spacer $px={10} />
      <Label>NAME</Label>
      <div className="value">{data.name || '-'}</div>
      <Spacer $px={10} />
      <div className="grid grid--3">
        <div>
          <Label>SOURCES</Label>
          <div className="value">{getRiskSourcesName(data.source) || '-'}</div>
        </div>
        <div>
          <Label>EVENTS</Label>
          <div className="value">{getRiskEventsName(data.event) || '-'}</div>
        </div>
        <div>
          <Label>CONSEQUENCES</Label>
          <div className="value">{getRiskConsequencesName(data.consequence) || '-'}</div>
        </div>
      </div>
      <Spacer $px={10} />
      <Label>RISK NARRATIVE</Label>
      <div className="value">{data.riskNarrative ? linkifyText(data.riskNarrative) : '-'}</div>
      <Spacer $px={10} />
      <S.Frequency>
        <S.Grow>
          <Label>FREQUENCY</Label>
          <div className="value">{data.frequencyTimes ?? '-'}</div>
        </S.Grow>
        <S.LabelBox>
          <Label>TIMES EVERY</Label>
        </S.LabelBox>
        <div className="value">{data.frequencyYears ?? '-'}</div>
        <S.LabelBox>
          <Label>YEAR(S)</Label>
        </S.LabelBox>
      </S.Frequency>
      <Spacer $px={10} />
      <Label>FREQUENCY - NOTE</Label>
      <div className="value">{data.frequencyNote ? linkifyText(data.frequencyNote) : '-'}</div>
      <Spacer $px={10} />
      <Label>CONSEQUENCE - LOWER</Label>
      <div className="value">{data.lowerFormula ? <FormulaPreview value={data.lowerFormula} /> : '-'}</div>
      <Spacer $px={10} />
      <Label>CONSEQUENCE - UPPER</Label>
      <div className="value">{data.upperFormula ? <FormulaPreview value={data.upperFormula} /> : '-'}</div>
      <Spacer $px={10} />
      <Label>CONSEQUENCE - NOTE</Label>
      <div className="value">{data.note ? linkifyText(data.note) : '-'}</div>
    </Wrap>
  );
};
